var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeaderPricing = function SvgIconHeaderPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    d: "M5.3 15.967c0 .158.126.288.287.288h8.829c.158 0 .287-.13.287-.288v-1.05H5.3zM17.058 6.763a.29.29 0 0 0-.345.011l-3.797 3.019-2.665-4.909c-.098-.186-.402-.183-.503 0L7.083 9.793 3.286 6.774a.285.285 0 0 0-.341-.011.29.29 0 0 0-.112.324l2.358 7.255h9.62l2.356-7.255a.29.29 0 0 0-.11-.324"
  })));
};
export default SvgIconHeaderPricing;